import fsharp from "refractor/fsharp";
export default fsharp;